import React from "react"
import styled from "@emotion/styled"
import { graphql, navigate } from "gatsby"
import { Row } from "react-flexgrid"

import Layout from "../components/Layout"
import SEO from "../components/Seo"

import KatachiProjectCard from "../components/ProjectCards/KatachiProjectCard"
import EmptyCard from "../components/ProjectCards/EmptyCard"

const StyledRow = styled(Row)`
  display: grid;
  grid-template-columns: 50% 50%;
  
  @media (max-width: 840px) {
    grid-template-columns: 100%;
  }
`

class BlogIndex extends React.Component {
  static navigateTo(slug) {
    navigate(slug)
  }

  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const { github } = data;
    const posts = data.allMarkdownRemark.edges
    return (
      <Layout includeHeader title={siteTitle} didClickContact={this.toggleContactModal}>
        <SEO
          title="Projects"
          keywords={["blog", "gatsby", "javascript", "react", "Alex Catchpole", "alexcatch"]}
        />
        <StyledRow>
          <KatachiProjectCard info={github.katachi}/>
          <EmptyCard colourOne="#F6D365" colourTwo="#FDA085" big/>
          <EmptyCard colourOne="#0ACFFE" colourTwo="#7579FF" big/>
          <EmptyCard colourOne="#96E6A1" colourTwo="#D4FC79"/>
        </StyledRow>
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }, filter: { frontmatter: { draft: { eq: false } } }) {
      edges {
        node {
          excerpt(pruneLength: 125)
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            section,
          }
        }
      }
    },
    github {
      ...KatachiRepository
    }
  }
`
